import React, { useState } from "react";
import "./CorporatePageElementsCss/CorporatePayment.css";
import toast from "react-hot-toast";
import { getUserData, setUserData } from "../../utils/auth";
import { getQrCodeforPayment, payForCorporate, userLogin } from "../../api/api";

const CorpoaretePayment = ({ open, onClose, balance, onPay }) => {
  const [amt, setAmt] = useState("");
  const [error, setError] = useState("");
  const [showQr, setShowQr] = useState(false);
  const data = getUserData();
  const [qrImage, setQrImage] = useState(null);
  const [qrLink, setQrLink] = useState("");
  const [qrId, setQrId] = useState("");
  const storedUser = JSON.parse(localStorage.getItem("rb_corp_creds"));
  if (!open) return null;

  const minAmt = 1;

  const generateBillId = (cccode) => {
    const now = new Date();

    const yyyy = now.getFullYear();
    const MM = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const HH = String(now.getHours()).padStart(2, "0");
    const mm = String(now.getMinutes()).padStart(2, "0");
    const ss = String(now.getSeconds()).padStart(2, "0");

    const timestamp = `${yyyy}${MM}${dd}${HH}${mm}${ss}`;

    return `${cccode}_Q${timestamp}`;
  };

  const handleChange = (e) => {
    setAmt(e.target.value);
    setError("");
  };

  const handlePayWithQR = async () => {
    const val = parseFloat(String(amt).replace(/[^0-9.]/g, ""));
    
  if (!val || val < minAmt) {
        setError(`Minimum amt is ₹${minAmt}`);
        return;
      }
    try {
      const BillID = generateBillId(data?.CCcode);
      const payload = {
        amount: val,
        CENTER_ID: data?.centerid,
        cc_user: data?.CCcode,
        customerId: data?.user_id,
        email: "nomail@gmail.com",
        name: data?.username,
        BillID,
      };

      const response = await getQrCodeforPayment(payload);
      console.log("QR Code Payment Response:", response);

      // ✅ Store data from response body
      setQrImage(response?.data?.body?.image);
      setQrLink(response?.data?.body?.qrData);
      setQrId(response?.data?.body?.qrCodeId);
      setShowQr(true);
    } catch (err) {
      toast.error("Failed to initiate payment via QR Code. Please try again.");
    }
  };

  const handleCorporateLogin = async () => {
    // e.preventDefault();

    try {
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        LoginType: "CC",
        mobile_no: storedUser?.mobile_no || "",
        password: storedUser?.password || "",
        deviceid: "",
      };

      const response = await userLogin(payload);
      console.log("Login response:", response);

      if (response?.data?.status === "success") {
        // ✅ Store user data using centralized helper
        setUserData(response.data);

        // Persist corporate credentials to localStorage
        try {
          localStorage.setItem(
            "rb_corp_creds",
            JSON.stringify({
              mobile_no: storedUser?.mobile_no || "",
              password: storedUser?.password || "",
            })
          );
        } catch (err) {
          console.warn("Could not save corporate credentials:", err);
        }

        console.log("Login successful:", response.data);

        // ✅ Redirect to dashboard
        // navigate("/corporate");
      } else {
        alert(response?.data?.message || "Invalid mobile number or password.");
      }
    } catch (error) {
      console.error("Error during login:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  const handleCloseQr = () => {
    setShowQr(false);
    handleCorporateLogin();
  };
  const handlePayUsingApp = async () => {
    const val = parseFloat(String(amt).replace(/[^0-9.]/g, ""));
    if (!val || val < minAmt) {
      setError(`Minimum amt is ₹${minAmt}`);
      return;
    }
    try {
      const payload = {
        BillID: generateBillId(data?.CCcode),
        amount: amt,
        
        email: "nomail@gmail.com",
        name: data?.username,
        customerId: data?.user_id,
        cc_user: data?.CCcode,
        CENTER_ID: data?.centerid,
      };
        const response = await payForCorporate(payload);
         if (response?.data?.url && response?.data?.form) {

      
      // Create a form dynamically
      const form = document.createElement("form");
      form.method = "POST";
      form.action = response.data.url;
      form.innerHTML = response.data.form;

      document.body.appendChild(form);
      form.submit(); // 🚀 Redirects to Paytm
    } else {
      console.error("Invalid Paytm response", response);
      toast.error("Payment initiation failed. Try again.");
    }
    } catch (err) {
      console.error("Error in payment using app", err);
    }
  };

  return (
    <>
      {showQr === false ? (
        <div className="cp-overlay" role="dialog" aria-modal="true">
          <div className="cp-modal">
            <div className="cp-header">
              <h3>Account Recharge</h3>
              <button className="cp-close" onClick={onClose}>
                ✕
              </button>
            </div>

            <div className="cp-body">
              <div className="cp-grid">
                <div className="cp-label">Your current balance is:</div>
                <div className="cp-balance">₹{balance}</div>
              </div>

              <div className="cp-grid">
                <div className="cp-label">
                  Enter the Amt to Recharge
                  <span className="cp-asterisk">*</span>:
                </div>
                <div className="cp-input-wrap">
                  <input
                    type="number"
                    className={`cp-input ${error ? "invalid" : ""}`}
                    placeholder={`Minimum amt is ₹${minAmt}`}
                    value={amt}
                    onChange={handleChange}
                    min={minAmt}
                  />
                </div>
              </div>
              {error && <div className="cp-error">{error}</div>}

              <div style={{ borderBottom: "1px solid #dcdcdc" }}></div>

              <div className="cp-actions">
                <button
                  className="cp-btn cp-green"
                  onClick={() => handlePayWithQR()}
                >
                  Payment Via QR Code
                </button>
                <button
                  className="cp-btn cp-green"
                  onClick={() => handlePayUsingApp()}
                >
                  Payment Via Other Option
                </button>
              </div>

              <div className="cp-notes">
                <div className="note">*Payment Process valid for 72hrs.</div>
                <div className="note">*Payment Process valid for 15 Mins</div>
              </div>

              <div className="cp-cancel-wrap">
                <button className="cp-cancel" onClick={onClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="cp-overlay">
          <div className="cp-modal">
            <div className="qr-header">
              <h3>Payment Via QR Code</h3>
              <button className="qr-close-x" onClick={() => setShowQr(false)}>
                ✕
              </button>
            </div>

            <div className="qr-body">
              <p>CC User: {data?.CCcode}</p>
              <p>Date: {new Date().toLocaleString()}</p>
              <p>Recharge Amount: ₹{amt}/-</p>

              <img
                src={`data:image/png;base64,${qrImage}`}
                alt="QR Code"
                className="qr-img"
              />

              <div className="qr-note">
                <strong>Note: </strong>
                This QR Code is valid for <b>72 hours only.</b>
              </div>

              <button className="qr-close-btn" onClick={() => handleCloseQr()}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CorpoaretePayment;
